export enum DocumentObjectType {
  docAndCert = 'Documents & Certificates',
  orientation = 'Orientation',
  workEligibility = 'Work Eligibility'
}
